import React from 'react';
import Box from '@material-ui/core/Box';
import { IProps } from './interfaces';
import moment from 'moment';

export const SideText = ({ mode, hasSideComponent, article }: IProps) => {
  const lastUpdatedDate = article?.data?.data?.lastUpdatedDate;
  const lastModifiedBy = article?.data?.data?.lastModifiedBy;
  const createdBy = article?.data?.data?.createdBy;
  const createdAt = article?.data?.data?.createdAt;
  const createText = () => {
    if (createdBy && createdAt) {
      return (
        <>
          Created by {createdBy} on{' '}
          {moment(createdAt).format('DD.MM.YYYY HH:mm')}
        </>
      );
    } else if (createdAt) {
      return <>Created on {moment(createdAt).format('DD.MM.YYYY HH:mm')}</>;
    } else if (createdBy) {
      return <>Created by {createdBy}</>;
    } else {
      return '';
    }
  };
  const editText = () => {
    if (lastModifiedBy && lastUpdatedDate) {
      return (
        <>
          Last edited by {lastModifiedBy} on{' '}
          {moment(lastUpdatedDate).format('DD.MM.YYYY HH:mm')}
        </>
      );
    } else if (lastUpdatedDate) {
      return (
        <>Last edited on {moment(lastUpdatedDate).format('DD.MM.YYYY HH:mm')}</>
      );
    } else if (lastModifiedBy) {
      return <>Last edited by {lastModifiedBy}</>;
    } else {
      return '';
    }
  };
  return (
    mode === 'update' &&
    hasSideComponent && (
      <Box textAlign="end">
        <div>
          <span style={{ fontStyle: 'italic' }}>{createText()} </span>
        </div>
        <div>
          <span style={{ fontStyle: 'italic' }}>{editText()} </span>
        </div>
      </Box>
    )
  );
};
